import FormIcon from '@material-ui/icons/Tune';
import FormViewComponent from './FormViewComponent';

const FormComponentInfo = {
  icon: FormIcon,
  component: FormViewComponent,
  multiData: false,
  initializeComponent: (compCfg, configuration, ctx) => {
    // For legacy reasons, form properties description are provided to the Form component as
    // a property and not among the component configuration.
    if (ctx.type && compCfg.properties) {
      const c = compCfg;
      c.properties = configuration.viewService.initalizeDataProperties(compCfg, ctx.type, true);
    }
  },
};

export default FormComponentInfo;
